import { gql } from '@apollo/client';

export const WebNoteFields = gql`
  fragment WebNoteFields on OdProtosNotesData_Note {
    id
    body
    user {
      token
      fullName
    }
    createdAt
  }
`;
